import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=4d9571f8"
import script from "./VisitsTable.vue?vue&type=script&lang=js"
export * from "./VisitsTable.vue?vue&type=script&lang=js"
import style0 from "./VisitsTable.vue?vue&type=style&index=0&id=4d9571f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports